import {MakeDialog} from "../../components/Shared/MakeDialog";
import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";

export class PromptDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: props.defaultValue || "",
    }
  }

  render() {
    return (
      <MakeDialog isOpen={true}
                  className={"PromptDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            onClick={() => this.props.onSave && this.props.onSave(this.state.comment)}>Save</Button>
                    <Button onClick={() => this.props.onCancel && this.props.onCancel()}>Cancel</Button>
                  </div>}
                  header={this.props.header || "Prompt"}>
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              {this.props.label && <Label for={"comment"}>{this.props.label}</Label>}
              <Input type="text" id="comment" placeholder=""
                     tabIndex={0}
                     value={this.state.comment || ""}
                     onChange={(evt) => this.setState({comment: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Shared/PromptDialog.js